import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DashboardView } from '../components/ui'

// import { ElevioIntegration } from '../components/ui/tools'

import { Grid } from '@material-ui/core'

import { setView } from '../redux/actions/select'
import { getCaptureData } from '../redux/actions'

import moment from 'moment'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenArrow: {
    color: '#A4D164',
    fontSize: '3.5rem',
    margin: 'auto'
  },
  redArrow: {
    color: '#F52604',
    fontSize: '3.5rem',
    margin: 'auto'
  },
  blueLine: {
    color: '#007bff',
    fontSize: '3.5rem',
    margin: 'auto'
  },
  taskCard: {
    height: '12em'
  },
  tableText: {
    fontWeight: 'bold',
    color: '#A4D164'
  },
  tableHeadText: {
    fontWeight: 'bold',
    color: '#007bff',
    padding: theme.spacing(2, 1)
  },
  table: {
  },
  tableContainer: {
    overflow: 'scroll',
    maxHeight: '16em'
  },
  bottomSkeleton: {
    marginBottom: '1rem'
  },
  capturePaper: {
    padding: theme.spacing(1.25),
    width: '100%'
  },
  weekTrendPaper: {
    padding: theme.spacing(1.25),
    width: '100%'
  },
  dailyTrendPaper: {
    padding: theme.spacing(1.25),
    width: '100%'
  },
  weekTrendGraph: {
    padding: theme.spacing(1.25),
    height: '98%',
    maxHeight: '21.5em'
  },
  problemPaper: {
    padding: theme.spacing(1.25),
    height: '98%',
    maxHeight: '21.5em'
  },
  captureNumPaper: {
    padding: theme.spacing(1.25),
    width: '100%',
    height: '100%',
    maxHeight: '21.5em'
  },
  categoryPaper: {
    padding: theme.spacing(1.25),
    width: '100%',
    height: '100%',
    maxHeight: '21.5em'
  },
  severityPaper: {
    padding: theme.spacing(1.25),
    width: '100%',
    height: '100%',
    maxHeight: '21.5em'
  }
}))

const CaptureDashboardView = props => {
  const dispatch = useDispatch()

  const Filter = useSelector(state => state.selection.Filter)
  // const CaptureData = useSelector(state => state.captureData.captureData)

  // data for weeks
  const [thisWeekSearch, setThisWeekSearch] = useState()
  const [lastWeekSearch, setLastWeekSearch] = useState()

  // top 5 problem users
  const [topProblemUsers, setTopProblemUsers] = useState()

  const [thisWeekDays, setThisWeekDays] = useState()
  const [thisWeekCount, setThisWeekCount] = useState()

  // const [lastWeekDays, setLastWeekDays] = useState()
  const [lastWeekCount, setLastWeekCount] = useState()

  // categories
  const [categories, setCategories] = useState()
  const [categoryNames, setCategoryNames] = useState()
  const [categoryValues, setCategoryValues] = useState()

  // percentage comparison values for captures
  const [weeklyPercentage, setWeeklyPercentage] = useState(null)
  const [dailyPercentage, setDailyPercentage] = useState(null)

  // captures in last 24 hours
  const [recentCaptureNumber, setRecentCaptureNumber] = useState()

  // number of captures by severity
  const [mildSeverity, setMildSeverity] = useState()
  // console.log(mildSeverity)
  const [mildModerateSeverity, setMildModerateSeverity] = useState()
  const [moderateSeverity, setModerateSeverity] = useState()
  const [moderateSevereSeverity, setModerateSevereSeverity] = useState()
  const [severeSeverity, setSevereSeverity] = useState()

  const [success, setSuccess] = useState(false)

  useEffect(() => {
    dispatch(getCaptureData(Filter, setData))
  }, [dispatch, Filter])

  const setData = (data) => {
    if (data) {
      setThisWeekSearch(data.this_week_search)
      setLastWeekSearch(data.last_week_search)
      setCategories(data.this_week_search.categories.buckets)
      setTopProblemUsers(data.all_problems.problem_users.buckets)
      setRecentCaptureNumber(data.recent_captures_search.doc_count)
      setSuccess(true)
    }
  }

  useEffect(() => {
    dispatch(setView('dashboard'))
  }, [dispatch])

  // assigns labels to weekdays and sets arrays for weekdays and data
  useEffect(() => {
    const thisWeekDayList = []
    const thisWeekCountList = []

    const lastWeekDayList = []
    const lastWeekCountList = []

    const mildList = []
    const mildModerateList = []
    const moderateList = []
    const moderateSevereList = []
    const severeList = []

    if (typeof thisWeekSearch === 'object' && typeof lastWeekSearch === 'object') {
      if (typeof thisWeekSearch.day_0 === 'object' && typeof lastWeekSearch.day_0 === 'object') {
        const { doc_count: thisCount = 0 } = thisWeekSearch.day_0
        const { doc_count: lastCount = 0 } = lastWeekSearch.day_0

        const thisWeekDay0 = thisWeekSearch.day_0

        thisWeekDayList.push(thisWeekSearch.day_0.label = moment().format('ddd'))
        thisWeekCountList.push(thisCount)

        lastWeekDayList.push(lastWeekSearch.day_0.label = moment().format('ddd'))
        lastWeekCountList.push(lastCount)

        mildList.push(thisWeekDay0.mild.doc_count)
        mildModerateList.push(thisWeekDay0.mild_moderate.doc_count)
        moderateList.push(thisWeekDay0.moderate.doc_count)
        moderateSevereList.push(thisWeekDay0.moderate_severe.doc_count)
        severeList.push(thisWeekDay0.severe.doc_count)

        setWeeklyPercentage(Math.round(((thisCount - lastCount) / (lastCount || 1)) * 100))
      }

      if (typeof thisWeekSearch.day_1 === 'object' && typeof lastWeekSearch.day_1 === 'object') {
        const thisWeekDay1 = thisWeekSearch.day_1

        thisWeekDayList.push(thisWeekDay1.label = moment().subtract(1, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay1.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_1.label = moment().subtract(1, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_1.doc_count)

        mildList.push(thisWeekDay1.mild.doc_count)
        mildModerateList.push(thisWeekDay1.mild_moderate.doc_count)
        moderateList.push(thisWeekDay1.moderate.doc_count)
        moderateSevereList.push(thisWeekDay1.moderate_severe.doc_count)
        severeList.push(thisWeekDay1.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_2 === 'object' && typeof lastWeekSearch.day_2 === 'object') {
        const thisWeekDay2 = thisWeekSearch.day_2

        thisWeekDayList.push(thisWeekDay2.label = moment().subtract(2, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay2.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_2.label = moment().subtract(2, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_2.doc_count)

        mildList.push(thisWeekDay2.mild.doc_count)
        mildModerateList.push(thisWeekDay2.mild_moderate.doc_count)
        moderateList.push(thisWeekDay2.moderate.doc_count)
        moderateSevereList.push(thisWeekDay2.moderate_severe.doc_count)
        severeList.push(thisWeekDay2.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_3 === 'object' && typeof lastWeekSearch.day_3 === 'object') {
        const thisWeekDay3 = thisWeekSearch.day_3

        thisWeekDayList.push(thisWeekDay3.label = moment().subtract(3, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay3.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_3.label = moment().subtract(3, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_3.doc_count)

        mildList.push(thisWeekDay3.mild.doc_count)
        mildModerateList.push(thisWeekDay3.mild_moderate.doc_count)
        moderateList.push(thisWeekDay3.moderate.doc_count)
        moderateSevereList.push(thisWeekDay3.moderate_severe.doc_count)
        severeList.push(thisWeekDay3.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_4 === 'object' && typeof lastWeekSearch.day_4 === 'object') {
        const thisWeekDay4 = thisWeekSearch.day_4

        thisWeekDayList.push(thisWeekDay4.label = moment().subtract(4, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay4.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_4.label = moment().subtract(4, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_4.doc_count)

        mildList.push(thisWeekDay4.mild.doc_count)
        mildModerateList.push(thisWeekDay4.mild_moderate.doc_count)
        moderateList.push(thisWeekDay4.moderate.doc_count)
        moderateSevereList.push(thisWeekDay4.moderate_severe.doc_count)
        severeList.push(thisWeekDay4.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_5 === 'object' && typeof lastWeekSearch.day_5 === 'object') {
        const thisWeekDay5 = thisWeekSearch.day_5

        thisWeekDayList.push(thisWeekDay5.label = moment().subtract(5, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay5.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_5.label = moment().subtract(5, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_5.doc_count)

        mildList.push(thisWeekDay5.mild.doc_count)
        mildModerateList.push(thisWeekDay5.mild_moderate.doc_count)
        moderateList.push(thisWeekDay5.moderate.doc_count)
        moderateSevereList.push(thisWeekDay5.moderate_severe.doc_count)
        severeList.push(thisWeekDay5.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_6 === 'object' && typeof lastWeekSearch.day_6 === 'object') {
        const thisWeekDay6 = thisWeekSearch.day_6

        thisWeekDayList.push(thisWeekDay6.label = moment().subtract(6, 'd').format('ddd'))
        thisWeekCountList.push(thisWeekDay6.doc_count)

        lastWeekDayList.push(lastWeekSearch.day_6.label = moment().subtract(6, 'd').format('ddd'))
        lastWeekCountList.push(lastWeekSearch.day_6.doc_count)

        mildList.push(thisWeekDay6.mild.doc_count)
        mildModerateList.push(thisWeekDay6.mild_moderate.doc_count)
        moderateList.push(thisWeekDay6.moderate.doc_count)
        moderateSevereList.push(thisWeekDay6.moderate_severe.doc_count)
        severeList.push(thisWeekDay6.severe.doc_count)
      }

      if (typeof thisWeekSearch.day_0 === 'object' && typeof thisWeekSearch.day_1 === 'object') {
        const { doc_count: todayCount = 0 } = thisWeekSearch.day_0
        const { doc_count: yesterdayCount = 0 } = thisWeekSearch.day_1
        setDailyPercentage(Math.round(((todayCount - yesterdayCount) / (yesterdayCount || 1)) * 100))
      }

      setThisWeekDays(thisWeekDayList.reverse())
      setThisWeekCount(thisWeekCountList.reverse())

      // setLastWeekDays(lastWeekDayList.reverse())
      setLastWeekCount(lastWeekCountList.reverse())

      setMildSeverity(mildList.reverse())
      setMildModerateSeverity(mildModerateList.reverse())
      setModerateSeverity(moderateList.reverse())
      setModerateSevereSeverity(moderateSevereList.reverse())
      setSevereSeverity(severeList.reverse())
    }
  }, [thisWeekSearch, lastWeekSearch])

  // maps through data to set categories for the pie chart config
  useEffect(() => {
    if (categories) {
      if (categories.length === 0) {
        setCategoryValues([0])
        setCategoryNames(['Recent Categories'])
      } else {
        const categoryNameList = []
        const categoryValueList = []
        categories.forEach((category) => {
          const categoryName = category.key
          const categoryValue = category.doc_count
          categoryNameList.push(categoryName)
          categoryValueList.push(categoryValue)
        })
        setCategoryNames(categoryNameList)
        setCategoryValues(categoryValueList)
      }
    }
  }, [categories, thisWeekSearch, lastWeekSearch])

  // start of chart configurations
  const barChartConfig = {
    labels: thisWeekDays,
    datasets: [{
      data: thisWeekCount,
      backgroundColor: '#007bff',
      borderColor: '#007bff',
      borderWidth: 4,
      padding: 4,
      pointBackgroundColor: '#007bff',
      label: 'Number of Captures'
    }]
  }

  const pieChartConfig = {
    labels: categoryNames,
    datasets: [{
      data: categoryValues,
      backgroundColor: ['#007bff', '#A4D163', '#F9BA02', '#F52604', '#929292'],
      borderColor: ['#007bff', '#A4D163', '#F9BA02', '#F52604', '#929292'],
      borderWidth: 4,
      padding: 4,
      pointBackgroundColor: '#007bff'
    }]
  }

  const stackedChartConfig = {
    labels: thisWeekDays,
    datasets: [
      {
        label: '1-20',
        data: mildSeverity,
        backgroundColor: '#007bff' // blue
      },
      {
        label: '21-40',
        data: mildModerateSeverity,
        backgroundColor: '#A4D163' // green
      },
      {
        label: '41-60',
        data: moderateSeverity,
        backgroundColor: '#929292' // grey
      },
      {
        label: '61-80',
        data: moderateSevereSeverity,
        backgroundColor: '#F9BA02' // orange
      },
      {
        label: '81-100',
        data: severeSeverity,
        backgroundColor: '#F52604' // red
      }
    ]
  }

  const previousWeekData = {
    label: 'Previous Week',
    data: lastWeekCount,
    backgroundColor: 'transparent',
    borderColor: '#A4D163',
    borderWidth: 4,
    padding: 4,
    pointBackgroundColor: '#A4D163',
    lineTension: 0
  }

  const currentWeekData = {
    label: 'Current Week',
    data: thisWeekCount,
    backgroundColor: 'transparent',
    borderColor: '#007bff',
    borderWidth: 4,
    padding: 4,
    pointBackgroundColor: '#007bff',
    lineTension: 0
  }

  const lineChartConfig = {
    labels: thisWeekDays,
    datasets: [previousWeekData, currentWeekData]
  }
  // end of chart configurations

  return (
    <>
      <Grid
        item
        container
        justify='center'
        style={{ paddingTop: '50px', paddingBottom: '50px', paddingLeft: '100px', paddingRight: '100px' }}
      >
        <DashboardView
          barChartConfig={barChartConfig}
          pieChartConfig={pieChartConfig}
          stackedChartConfig={stackedChartConfig}
          lineChartConfig={lineChartConfig}
          dailyPercentage={dailyPercentage}
          weeklyPercentage={weeklyPercentage}
          recentCaptureNumber={recentCaptureNumber}
          topProblemUsers={topProblemUsers}
          success={success}
          useStyles={useStyles}
        />
        {/* <ElevioIntegration keywords={['Dashboard']} /> */}
      </Grid>
      {/* <div
        className='grid row justify-content-center no-gutters'
        style={{ paddingTop: '50px', paddingBottom: '50px', paddingLeft: '120px', paddingRight: '120px' }}
      >
      </div> */}
    </>
  )
}

export default CaptureDashboardView
